import { Reducer } from 'redux';

import { AnnouncementsAnnounce, AnnouncementsClear } from '../../domains/announcements/actions.types';

import { Announcements } from './types';

export type AnnouncementsAction = AnnouncementsAnnounce | AnnouncementsClear;

const initialState: Announcements = {
  current: undefined,
};

const reducer: Reducer<Announcements, AnnouncementsAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'ANNOUNCEMENTS.ANNOUNCE':
      return {
        current: action.payload,
      };
    case 'ANNOUNCEMENTS.CLEAR':
      return initialState;
    default:
      return state;
  }
};

export default reducer;
